import { NIMMSTA } from '../../NIMMSTA';
export class CheckCompatibilityAction {
    constructor() {
        this.name = 'CheckCompatibility';
        this.isDeviceAction = false;
        this.data = { version: NIMMSTA.version };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2tDb21wYXRpYmlsaXR5QWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9tb2RlbHMvYWN0aW9ucy9DaGVja0NvbXBhdGliaWxpdHlBY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLGVBQWUsQ0FBQztBQU94QyxNQUFNLE9BQU8sd0JBQXdCO0lBQXJDO1FBQ2tCLFNBQUksR0FBRyxvQkFBb0IsQ0FBQztRQUM1QixtQkFBYyxHQUFHLEtBQUssQ0FBQztRQUNoQyxTQUFJLEdBQXdCLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxPQUFPLEVBQUUsQ0FBQztJQUNsRSxDQUFDO0NBQUEifQ==